export enum DataTypeEnum {
    NUMERIC = 'Numeric',
    CATEGORICAL = 'Categorical',
    CHARACTER = 'Character',
    DATE = 'Date'
}

export enum DataTypeIdEnum {
    NUMERIC = 1110,
    CATEGORICAL = 1130,
    CHARACTER = 1120,
    DATE = 1117
}
